module.exports = __webpack_public_path__ + "img/SUPER8.a12b970d.png";